import { CourseTopic } from "../response/Course_Topic_Response";

// src/store/GlobalStore.ts
class RecommendationIndustryViewInstance {
  private static instance: RecommendationIndustryViewInstance;
  selectedItem: CourseTopic | null = null;

  private constructor() {}

  public static getInstance(): RecommendationIndustryViewInstance {
    if (!RecommendationIndustryViewInstance.instance) {
      RecommendationIndustryViewInstance.instance =
        new RecommendationIndustryViewInstance();
    }
    return RecommendationIndustryViewInstance.instance;
  }

  // Setter methods to update state
  setSelectedItem(item: CourseTopic | null) {
    this.selectedItem = item;
  }

  // Getter methods to retrieve state
  getSelectedItem() {
    return this.selectedItem;
  }
  clearState() {
    this.selectedItem = null; // Resetting the state to initial values
  }
}

export const recommendationIndustryViewInstance_Store =
  RecommendationIndustryViewInstance.getInstance();
